export const CapitalCase = function(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}